import { useEffect, useState } from 'react';
import { CaptchaConfig, getCaptchaConfig } from '../api/client';

export interface TurnstileCaptchaState {
  loading: boolean;
  required: boolean;
  siteKey: string | null;
}

export function useCaptchaConfig(): TurnstileCaptchaState {
  const [state, setState] = useState<TurnstileCaptchaState>({
    loading: true,
    required: false,
    siteKey: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cfg: CaptchaConfig = await getCaptchaConfig();
        if (cancelled) return;
        const turnstile = cfg.turnstile;
        const siteKey =
          turnstile?.site_key && turnstile.site_key.trim().length > 0
            ? turnstile.site_key.trim()
            : null;
        const required = turnstile?.required === true && siteKey != null;
        setState({ loading: false, required, siteKey });
      } catch {
        if (!cancelled) {
          setState({ loading: false, required: false, siteKey: null });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
